<template>
  <div class="section fill">
    <div class="inner">
      <!-- Tab START -->
      <div class="link_tab">
        <ul>
          <li
            v-for="tab in tabs"
            :key="tab.value"
            :class="[current === tab.value ? 'active' : '']"
          >
            <a class="link_tab_menu" @click="sendActivetab(tab)">
              {{ tab.text }}
            </a>
          </li>
        </ul>
        <div class="btn_wrap">
          <router-link :to="{ name: 'selfbook_upload' }" class="btn_make_sbook"
            ><span class="c_icon"></span
            ><span class="an_t">{{
              $t('selfbook.linktab.9052')
            }}</span></router-link
          >
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkTab',
  props: {
    tabs: {
      /*
      [{ text: "", value: "" }]
      */
      type: Array,
      required: true
    },
    current: {
      type: String,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    sendActivetab(tab) {
      this.$emit('tab-clicked', tab)
    }
  }
}
</script>

<style lang="scss" scoped></style>
